import React, { Component } from 'react';
import { DropdownButton, Dropdown, OverlayTrigger, Tooltip } from 'react-bootstrap';
import PubSub from 'pubsub-js';

class AutoDraw extends Component {

    constructor(props) {
        super(props);
        this.state = {
            singleSelection: "",
            supRes: true,
            trend: true
        };
        this.globalOptions = [];
    }

    onSelectInput = (e) => {
        let value = e.target.value;
        // let checked = e.target.checked;

        //let tmpAlgorithms = []; //Single selection
        // console.log('autoDrawSelected tmpautoDrawSelected', value, checked);
        // let tmpObj = { name: value, selected: checked };
        // //tmpAlgorithms.push(tmpObj);
        // this.globalOptions.push(tmpObj);
        // console.log('autoDrawSelected autoDrawSelected1', this.globalOptions);
        
        if (value === 'supRes') {
            this.setState({ supRes: !this.state.supRes },() =>{this.publish()});                            
        } 
        if (value === 'trend') {
            this.setState({ trend: !this.state.trend },() =>{this.publish()}); 
        }
    }

    publish(){
        this.globalOptions = [];   
        this.globalOptions.push({name: 'supRes', selected: this.state.supRes});
        this.globalOptions.push({name: 'trend', selected: this.state.trend});
        PubSub.publish('autoDrawSelected', this.globalOptions);
    }

    render() {
        return (
            <OverlayTrigger
                placement="top"
                overlay={<Tooltip id="button-tooltip-2">Auto draws the selected options</Tooltip>}
            >
                <DropdownButton id="algorithms" title={'Auto Draw'} size="sm">
                    <Dropdown.Item href="#/supportResistance">
                        <input type="checkbox" ref="inputElem" autoComplete="off" name="supRes" placeholder="supportResistance"
                            value="supRes" onChange={this.onSelectInput} checked={this.state.supRes}
                        /> Support/Resistance
                    </Dropdown.Item>
                    <Dropdown.Item href="#/trend">
                        <input type="checkbox" ref="inputElem" autoComplete="off" name="trend" placeholder="trend"
                            value="trend" onChange={this.onSelectInput} checked={this.state.trend}
                        /> Trend
                    </Dropdown.Item>

                </DropdownButton>
            </OverlayTrigger>
        )
    };
}

export default AutoDraw;